import jwt_decode from "jwt-decode";

export const authTokenCookie = (props) => {
  //gets cookie and returns it as a key=value object
  try {
    let cookies = document.cookie ? document.cookie.split(";") : null;
    let cookieVal;
    let idcookie;
    let idField;
    let fields;
    let cookieUrl;
    if (cookies) {
      let cookie = cookies.filter(cookie => cookie.includes("ent-abs-auth"));
      idcookie = cookies.find(cookie => cookie.includes("ent-abs-itkn"));
      cookieVal = cookie.length ? cookie[0] : null;
      cookieUrl=cookies.find(cookie=>cookie.includes("abs-url"));
    }
    fields = cookieVal ? cookieVal.split("=") : null;
    idField = idcookie ? idcookie.split("=") : null;
    const authCookie = {
      name: fields ? fields[1] : null,
    };
    let token = authCookie.name ? authCookie.name : null;
    let idToken = idField ? idField[1] : null;
    let decodedToken = token ? jwt_decode(token) : null;
    let decodedIdToken = idToken ? jwt_decode(idToken) : null;
   // token = token && token.split("%22");
   // idToken = idToken && idToken.split("%22");
   if (props) {
    let authorizedRoles = props.find((app) => app.applicationDetail.includes(`Customer Comments`))
    let aRoles = authorizedRoles?.appUserRole?.length > 0 ? authorizedRoles.appUserRole.split(`,`) : undefined;
    let fRoles = aRoles?.filter((role) => decodedIdToken?.roles?.indexOf(role) !== -1);
//       sessionStorage.setItem('userRole', fRoles)
    sessionStorage.setItem('userRole', fRoles.length > 0?fRoles :decodedIdToken?.roles[0])
  }
  return {
      authCookie,
      token,
      idToken,
      userInfo: {
        name: (decodedIdToken && decodedIdToken.name) ? decodedIdToken.name : null,
        userId: (decodedIdToken && decodedIdToken.onpremisessamaccountname) ? decodedIdToken.onpremisessamaccountname : null,
        emailId: (decodedIdToken && decodedIdToken.preferred_username) ? decodedIdToken.preferred_username : null,
        userRole: (decodedIdToken && decodedIdToken.roles && decodedIdToken.roles[0]) ? sessionStorage.getItem('userRole') : null,
        allUserRole: (decodedIdToken && decodedIdToken.roles && decodedIdToken.roles[0]) ? decodedIdToken.roles : null,
        userStore: (decodedIdToken && decodedIdToken.swyFacilityCode) ? decodedIdToken.swyFacilityCode : null,
        userDistrict: (decodedIdToken && decodedIdToken.swyDistrict) ? decodedIdToken.swyDistrict : null,
        userDivision: (decodedIdToken && decodedIdToken.swyDivision) ? decodedIdToken.swyDivision : null,
      },
      authUrl:cookieUrl,
      tid: decodedToken ? decodedToken.tid : null,
      decodedToken: decodedToken,
      decodedIdToken:decodedIdToken
    }

  } catch (err) {
    console.log("CookieError:--------------");
    console.log(err);
    console.log("CookieErrorEnds:--------------");
  }

};
